import React from "react"
import { routePaths } from "../.."
import { OrgAuthCheck } from "../../../Components/Common/AuthCheck/OrgAuthCheck"
import { defaultOrgMemberSort } from "../../../Components/Views/Dashboard/Sections/Organization/Common/constants"
import { MemberList } from "../../../Components/Views/Dashboard/Sections/Organization/MemberList"
import { useDecodeFilterAndSort } from "../../../Hooks/useDecodeFilterAndSort"
import { OrgRouteComponentProps } from "../../RouteProps"

export function MemberListRoute({
    match,
    location
}: OrgRouteComponentProps<{}>) {
    const { sort } = useDecodeFilterAndSort(
        location.search,
        defaultOrgMemberSort,
        routePaths.orgMemberList(match.params.orgUsername)
    )

    return (
        <OrgAuthCheck
            orgUsername={match.params.orgUsername}
            scope="member:view"
        >
            <MemberList orgUsername={match.params.orgUsername} sort={sort} />
        </OrgAuthCheck>
    )
}
